import { useState } from 'react';
import WorkCard from '@/components/WorkCard';
import { works } from '@/mocks/doujin';

type TabKey = 'translations' | 'serial' | 'new';

export default function Discovery() {
  const [tab, setTab] = useState<TabKey>('translations');

  const tabs: { key: TabKey; label: string; desc: string }[] = [
    { key: 'translations', label: '最新汉化', desc: '近期汉化完成的热门作品' },
    { key: 'serial', label: '连载追踪', desc: '正在稳定连载更新的作品' },
    { key: 'new', label: '新作预告', desc: '即将开坑的全新连载' },
  ];

  const list =
    tab === 'translations'
      ? works.filter((w) => w.status === '汉化完成')
      : tab === 'serial'
        ? works.filter((w) => w.status === '连载中')
        : works.filter((w) => w.status === '即将开坑');

  const current = tabs.find((t) => t.key === tab)!;

  return (
    <section className="px-4 md:px-6 max-w-7xl mx-auto py-14 md:py-20">
      <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-8">
        <div>
          <p className="flex items-center gap-2 text-primary-700 text-sm font-medium">
            <i className="ri-command-line"></i> DISCOVER
          </p>
          <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">汉化连载，追更推荐</h2>
          <p className="mt-2 text-foreground-500 text-sm md:text-base">{current.desc}</p>
        </div>
        <div className="flex items-center gap-1 bg-background-100 p-1 rounded-full self-start lg:self-auto">
          {tabs.map((t) => (
            <button
              key={t.key}
              type="button"
              onClick={() => setTab(t.key)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                tab === t.key
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-600 hover:text-primary-700'
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5">
        {list.map((w) => (
          <WorkCard key={w.slug} work={w} />
        ))}
      </div>
    </section>
  );
}